import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const JOIN_FAIR_PLAY_START = 'FAIR_PLAY :: JOIN_START';

export type TJoinFairPlayStartAction = IReduxAction<typeof JOIN_FAIR_PLAY_START>;

/**
 * @description Старт запроса на заявку участия в акции "Честная игра"
 */
export const joinFairPlayStart = actionGenerator<typeof JOIN_FAIR_PLAY_START>(JOIN_FAIR_PLAY_START);
